/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */

export type InventoryCategoryEnum = typeof InventoryCategoryEnum[keyof typeof InventoryCategoryEnum];


export const InventoryCategoryEnum = {
  COMMODITY: 'commodity',
  COMPONENT: 'component',
  WEAPON: 'weapon',
  EQUIPMENT: 'equipment',
  AMMUNITION: 'ammunition',
  CONSUMABLE: 'consumable',
  OTHER: 'other',
  ARMOR: 'armor',
  CLOTHING: 'clothing',
  TOOL: 'tool',
  CONTAINER: 'container',
} as const;
